const { removeClass, addClass } = require('../../domUtil');
const { HIDDEN_CLASS, EMPTY_STRING } = require('../../constants');

/**
 * Function to add message safely and update its class
 * @param {HTMLElement} el - The source element
 * @param {string} message - store availability message
 * @param {string} selector - DOM element selector
 * @param {HTMLElement} container - Product container Element
 */
function injectMessageAndUpdateElementState(el, message) {
    if (el) {
        if (message) {
            el.innerHTML = message;
            removeClass(el, HIDDEN_CLASS);
        } else {
            el.textContent = EMPTY_STRING;
            addClass(el, HIDDEN_CLASS);
        }
    }
}

module.exports = {
    injectMessageAndUpdateElementState
};
